import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [showResend, setShowResend] = useState(false);
  const navigate = useNavigate()
  
  // const token = new URLSearchParams(useLocation().search).get('token')
  const params = new URLSearchParams(useLocation().search)
  const token = params.get('token')
  const email = params.get('email')

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')
    setMessage('')

    if (password !== confirm) {
      setError("Passwords don't match")
      return
    }

    try {
      const res = await fetch('/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.message)

      setMessage('Password reset! Redirecting to login…')
      setTimeout(() => navigate('/home'), 2000)
    } catch (err) {
      if (err.message.includes('expired')) {
        setShowResend(true);
        setError('Your link has expired. You can request a new one above 👆');
      } else {
        setError(err.message);
      }
    }
  }

  const handleResend = async () => {
    setError('')
    setMessage('')
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.message)
      setMessage('New activation link sent to your inbox 📥')
      setShowResend(false)
      setTimeout(() => navigate('/home'), 3000)
    } catch (err) {
      setError(err.message || 'Unable to resend link')
    }
  }

  if (!token) {
    return (
      <div className="app">
        <header className="login-header">
          <div className="logo-title">
            <img src="/Logo.png" alt="Company Logo" className="company-logo" />
            <h1>BelleFlamme Web Controller</h1>
            <img src="/Logo01.png" alt="Company Logo" className="company-logo-euro" />
          </div>
        </header>
        <div className="login-page">
          <p className="error-msg" style={{ visibility: 'visible', marginTop: 0 }}>
            Invalid or missing token.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="app">
      <header className="login-header">
        <div className="logo-title">
          <img src="/Logo.png" alt="Company Logo" className="company-logo" />
          <h1>BelleFlamme Web Controller</h1>
          <img src="/Logo01.png" alt="Company Logo" className="company-logo-euro" />
        </div>
      </header>

      <div className="login-page">
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Choose a new password</h2>
          <input 
            type="password" 
            placeholder="New password" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            placeholder="Confirm password" 
            value={confirm} 
            onChange={e => setConfirm(e.target.value)} 
            required 
          />
          <button type="submit">Reset Password</button>
          {showResend && (
            <button type="button" onClick={handleResend}>
              Resend Link
            </button>
          )}
          <p className={message ? 'success-msg' : error ? 'error-msg' : 'success-msg'} style={{ margin: 0, marginTop: '-10px', marginBottom: '25px' }}>
            {message || error || ''}
          </p>
        </form>
      </div>
    </div>
  )
}
